var React = require('react');

function HowWorks (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M42.1,40c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6C38.5,38.3,40.1,40,42.1,40L42.1,40z\n\t M62.7,66.1v-3.7H37.3v3.7H62.7z M50,5C25.1,5,5,25.1,5,50s20.1,45,45,45s45-20.1,45-45S74.9,5,50,5L50,5z M70,34.8H59.4V24.2\n\tL70,34.8z M71.3,76.2c0,0.5-0.4,0.9-0.9,0.9H29.6c-0.5,0-0.9-0.4-0.9-0.9V23.9c0-0.5,0.4-0.9,0.9-0.9H55v15.5c0,0.5,0.4,0.9,0.9,0.9\n\th15.5L71.3,76.2L71.3,76.2z M62.7,49.2v-3.6H37.3v3.6H62.7z M62.7,57.7V54H37.3v3.7H62.7z"}));
}

HowWorks.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","width":"25px","height":"25px","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = HowWorks;

HowWorks.default = HowWorks;
